/**
 *  All api related to system setting
 */

import _ from 'lodash'
import { CancelToken } from 'axios'

import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'
import config from '../../config'

export function fetchSystemSettings(params = {}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchSystemSettings',
    () => source.cancel('fetchSystemSettings: Operation cancelled by user')
  )

  let apiOptions = {
    method: 'get',
    params,
    cancelToken: source.token,
  }

  // get system settings from json
  const systemSettingsUrl = config.get('api.systemSettingsUrl')

  if (!_.isEmpty(systemSettingsUrl)) {
    // use system settings json url for api request
    apiOptions = {
      ...apiOptions,
      url: systemSettingsUrl,
    }
  } else {
    apiOptions = {
      ...apiOptions,
      endpoint: 'system_settings',
    }
  }

  return OmnitechApi
    .request(apiOptions)
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      systemSettings: data.systemSettings,
      cacheChecksum: _.get(cacheChecksum, 'systemSettingsValue'),
    }))
}
